class TimeslotAlertController {
    constructor($scope, $timeout, settings, shopPageStateService, fulfilmentService) {
        this.$timeout = $timeout;
        this.settings = settings;

        this.shopPageStateService = shopPageStateService;
        this.fulfilmentService = fulfilmentService;

        $scope.$on('http:success', () => this.scheduleReservationExpiredAlert());
    }

    $onInit() {
        if (this.reservedTimeslot && this.reservedTimeslot.TimeWindow) {
            /* Values for debugging */

            // For debugging window cutoffs
            // this.reservedTimeslot.MinutesToCutOff = 15 / 60;
            // this.settings.deliveryWindowAlerts.closingSoonAlertPeriod = 10 / 60;
            // this.settings.deliveryWindowAlerts.closingNowAlertPeriod = 5 / 60;

            // For debugging window reservation expiry
            // this.settings.deliveryWindows.reservationTimeout = 1 / 60;

            /* end debug values */

            this.scheduleReservationExpiredAlert();

            // ORDER MATTERS HERE, if these fire at the same time (e.g. we are in both the closing now and closing soon period)
            this.scheduleTimeslotClosingSoonAlert();
            this.scheduleTimeslotClosingNowAlert();
            this.scheduleTimeslotClosedAlert();
        }
    }

    $onDestroy() {
        this.unscheduleAlerts();
    }

    scheduleReservationExpiredAlert() {
        this.$timeout.cancel(this.reservationExpiryTimer);

        this.reservationExpiryTimer = this.scheduleAlert(() => {
            this.unscheduleAlerts();
            this.showAlert(this.settings.deliveryWindowAlerts.reservationExpiredAlertMessage);
            this.changeTimeslot();
        }, this.settings.deliveryWindows.reservationTimeout);
    }

    scheduleTimeslotClosedAlert() {
        this.$timeout.cancel(this.closedTimer);

        this.closedTimer = this.scheduleAlert(() => {
            this.showAlert(this.settings.deliveryWindowAlerts.closedAlertMessage);
            this.changeTimeslot();
            if (this.isExpress) this.isExpressClosed = true;
        }, this.reservedTimeslot.MinutesToCutOff);
    }

    scheduleTimeslotClosingNowAlert() {
        this.$timeout.cancel(this.closedTimer);

        this.closingNowTimer = this.scheduleAlert(() => {
            this.showAlert(this.settings.deliveryWindowAlerts.closingNowAlertMessage);
        }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingNowAlertPeriod);
    }

    scheduleTimeslotClosingSoonAlert() {
        this.$timeout.cancel(this.closingSoonTimer);

        this.closingSoonTimer = this.scheduleAlert(() => {
            this.showAlert(this.settings.deliveryWindowAlerts.closingSoonAlertMessage);
        }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingSoonAlertPeriod);
    }

    scheduleAlert(callback, minutesFromNow) {
        return this.$timeout(callback, minutesFromNow * 60 * 1000);
    }

    unscheduleAlerts() {
        this.$timeout.cancel(this.reservationExpiryTimer);
        this.$timeout.cancel(this.closingNowTimer);
        this.$timeout.cancel(this.closingSoonTimer);
        this.$timeout.cancel(this.closedTimer);
        this.isExpressClosed = false;
    }

    hideAlert() {
        this.alertMessage = null;
    }

    showAlert(alertMessage) {
        this.alertMessage = alertMessage;
    }

    changeTimeslot() {
        this.shopPageStateService.isCartOpen = true;
        this.fulfilmentService.changeFulfilmentTimeslot();
    }
}

TimeslotAlertController.$inject = ['$scope', '$timeout', 'Settings', 'ShopPageStateService', 'FulfilmentService'];

const timeslotAlertComponentDefinition = {
    bindings: {
        reservedTimeslot: '<',
        isExpress: '<',
    },
    controller: TimeslotAlertController,
    template: require('./timeslot-alert.component.html').trim(),
};

module.exports = {
    TimeslotAlertController,
    timeslotAlertComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/timeslots/timeslot-alert.component.js